module.exports = __webpack_public_path__ + "assets/img/serbia-joins-ludimos.3222a9ec.jpg";